module.exports = __webpack_public_path__ + "img/131.liked.bcbfdb1e.svg";